const formatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'medium',
  timeStyle: 'medium',
});
const formatterShort = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'medium',
});
export const formatDate = (date: Date) => formatter.format(date);
export const formatDateShort = (date: Date) => formatterShort.format(date);
